import { NgModule } from '@angular/core';


import { Routes, RouterModule } from '@angular/router';
import { NoInvitationComponent } from './modules/no-invitation/components/no-invitation/no-invitation.component';
import { AuthGuard } from './modules/core/services/authentication/auth-guard';



const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./modules/base-layout/base-layout.module').then(module => module.BaseLayoutModule),canActivate: [AuthGuard],
  },
  {
    path: 'recording',
    loadChildren: () => import('../app/modules/record-presentation/record-presentation.module').then(module => module.RecordPresentationModule),canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('../app/modules/sign-in/sign-in.module').then(module => module.SignInModule),
  },
  {
    path: 'player',
    loadChildren: () => import('../app/modules/video-player/video-player.module').then(module => module.VideoPlayerModule),canActivate: [AuthGuard],
  },
  {
    path: 'pdf-view',
    loadChildren: () => import('./modules/pdf-view/pdf-view.module').then(module => module.PdfViewModule),canActivate: [AuthGuard],
  },
  {
    path: 'full-screen-pdf',
    loadChildren: () => import('./modules/full-screen-pdf-viewer/full-screen-pdf-viewer.module').then(module => module.FullScreenPdfViewerModule),canActivate: [AuthGuard],
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }

